module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_franchises.1ba08c04.png";